<script setup lang="ts">
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'

defineOptions({
  name: 'InfoResumeSubscription',
})

</script>

<template>
  <ListTaskInfo class="hidden" />
</template>
